import React, { useEffect } from "react";
import RequestOTP from "@/pages/auth/RequestOTP";
import VerifyOTP from "@/pages/auth/VerifyOTP";
import CreateAccount from "@/pages/auth/CreateAccount";
import RegistrationCategories from "@/pages/auth/RegistrationCategories";
import SignIn from "@/pages/auth/SignIn";
import ForgotPasswordVerifyOTP from "@/pages/auth/ForgotPasswordVerifyOTP";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import SetNewPassword from "@/pages/auth/SetNewPassword";
import JourneySelection from "@/pages/auth/JourneySelection";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentForm,
  getFormProps,
  getIsModalOpen,
  setFormProps,
} from "@/reducers/commonSlice";
import UploadDocument from "@/components/document/UploadDocument";
import UploadCommentDocument from "@/components/document/UploadCommentDocument";
import "@/styles/components/formLoader.scss";
import DatePickerComponent from "@/components/datepicker";
import SetPrefrences from "@/pages/auth/SetPrefrences";
import SessionPurchasedSuccess from "@/components/purchase/SessionPurchasedSuccess";
import ProductPurchasedSucess from "@/components/purchase/ProductPurchasedSucess";
import DashboardDrawer from "@/components/DashboardDrawer/DashboardDrawer";
import ConfirmDelete from "@/components/form/ConfirmDelete";
import SuccessModal from "@/components/form/SuccessModal";
import VerifyPrimaryEmailOrMobileNumber from "@/pages/auth/VerifyPrimaryEmailOrMobileNumber";
import ChangePassword from "@/pages/auth/ChangePassword";
import ViewDocument from "@/components/form/ViewDocument";
import SelectSlot from "@/components/form/SelectSlot";
import HomePageOnboarding from "@/components/form/HomePageOnboarding";
import GuidePlatform from "@/pages/guide/GuidePlatform";
import ApplyForGuide from "@/pages/guide/ApplyForGuide";
import CloneSlot from "@/components/form/CloneSlot";
import MembershipDescription from "@/components/form/MembershipDescription";
import Report from "@/components/form/Report";
import VideoPlayer from "@/components/preview/VideoPlayer";
import RequestGraceTime from "@/components/form/RequestGraceTime";
import ApproveRejectGraceTime from "@/components/form/ApproveRejectGraceTime";
import RequestWithReason from "@/components/form/RequestWithReason";
import UpdateUnavailability from "@/components/form/UpdateUnavailability";
import CreateTask from "@/components/form/CreateTask";
import GuideSubmitted from "@/pages/guide/GuideSubmitted";
import MentorApplicationDescription from "@/components/form/MentorApplicationDescription";
import ReviewModal from "./ReviewModal";

const FORM_MAP = {
  signIn: SignIn,
  requestOTP: RequestOTP,
  verifyOTP: VerifyOTP,
  verifyPrimaryEmailOrPassword: VerifyPrimaryEmailOrMobileNumber,
  changePassword: ChangePassword,
  forgotPassword: ForgotPassword,
  forgotPasswordVerifyOTP: ForgotPasswordVerifyOTP,
  setNewPassword: SetNewPassword,
  createAccount: CreateAccount,
  registrationCategories: RegistrationCategories,
  journeySelection: JourneySelection,
  setPrefrences: SetPrefrences,
  bookASession: DatePickerComponent,
  sessionSuccess: SessionPurchasedSuccess,
  productSuccess: ProductPurchasedSucess,
  dashboardDocChat: UploadCommentDocument,
  dashboardDocuments: UploadDocument,
  dashboardDrawer: DashboardDrawer,
  confirmDelete: ConfirmDelete,
  successModal: SuccessModal,
  viewDocument: ViewDocument,
  selectSlot: SelectSlot,
  cloneSlot: CloneSlot,
  homePageOnboarding: HomePageOnboarding,
  guidePlatform: GuidePlatform,
  membershipDescription: MembershipDescription,
  report: Report,
  videoPlayer: VideoPlayer,
  requestGraceTime: RequestGraceTime,
  approveRejectGraceTime: ApproveRejectGraceTime,
  requestWithReason: RequestWithReason,
  updateUnavailability: UpdateUnavailability,
  createTask: CreateTask,
  guideSubmitted: GuideSubmitted,
  applyForGuide: ApplyForGuide,
  mentorApplicationDescription: MentorApplicationDescription,
  reviewModal: ReviewModal,
};
const FormLoader = () => {
  const dispatch = useDispatch();
  const currentForm = useSelector(getCurrentForm);
  const isOpen = useSelector(getIsModalOpen);
  const props = useSelector(getFormProps);
  const Form = currentForm ? FORM_MAP[currentForm] : <></>;
  useEffect(() => {
    if (!isOpen) {
      dispatch(setFormProps({}));
    }
  }, [isOpen]);
  return <Form isOpen={isOpen} {...props} />;
};

export default FormLoader;
